export const isValueDefined = (value: any) => value !== undefined && value !== null;

export const isActivityRecent = (activity: { openDate: string }, startDate = "2025-03-06") => (new Date(activity?.openDate)).getTime() >= (new Date(startDate)).getTime();

const trimStringValuesRecursively = (value: any): any => {
    if (typeof value === 'string') {
        return value.trim();
    }

    if (Array.isArray(value)) {
        return value.map(trimStringValuesRecursively);
    }

    if (value && Object.getPrototypeOf(value) === Object.prototype) {
        return Object.fromEntries(
            Object.entries(value).map(([key, nestedValue]) => [key, trimStringValuesRecursively(nestedValue)])
        );
    }

    return value;
};

export const trimAllStringValues = (obj: Record<string, any>) => {
    return trimStringValuesRecursively(obj);
}
